import { getNewCustomerDiscountExpiresAtUserSelect } from 'modules/training/modules/training-users/selectors/getNewCustomerDiscountExpiresAt/index.js'
import { getSubscriptionCanceledAtUserSelect } from 'modules/training/modules/training-users/selectors/getSubscriptionCanceledAt/index.js'
import { createSelector } from 'reselect'
import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium/index.js'

export const shouldShowNewCustomerDiscountTimerUserSelect = createSelector(
  getNewCustomerDiscountExpiresAtUserSelect,
  getSubscriptionCanceledAtUserSelect,
  hasPremiumUserSelect,
  (
    newCustomerDiscountExpiresAt,
    subscriptionCanceledAt,
    hasPremium
  ) => {
    if (hasPremium) {
      return false
    }

    if (subscriptionCanceledAt) {
      return false
    }

    if (!newCustomerDiscountExpiresAt) {
      return true
    }

    return new Date(newCustomerDiscountExpiresAt) > new Date()
  }
)
